//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 21/03/2025
// Version       : 1
// Description   : Lista de proveedores de combustibles
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React, { useState, useEffect, useMemo } from "react";
import { UrlApi } from "../../../services/apirest";
import Navbar from "../../Navbar";
import { MaterialReactTable } from "material-react-table";
import { logEventos } from "../../../services/services";
// TABLA EN ESPAÑOL
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  Box,
  Dialog,
  Typography,
  IconButton,
  Button,
  ThemeProvider,
  createTheme,
  useTheme,
  Tooltip,
} from "@mui/material";
import { lighten } from "@mui/material/styles";

import AgregarProveedor from "./AgregarProveedor";
import CambiarEstadoProveedor from "./CambiarEstadoProveedor";
import ConfiguracionReporte from "./ConfiguracionReporte";

// ICONOS
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import BlockIcon from "@mui/icons-material/Block";
import SettingsIcon from "@mui/icons-material/Settings";

function ProveedoresCombustible() {
  const globalTheme = useTheme();

  const [proveedoresCombustible, setProveedoresCombustible] = useState([]);

  //*************************************************************************************************************************************/

  const obtenerProveedores = () => {
    fetch(UrlApi + "/proveedores_combustible")
      .then((data) => data.json())
      .then((data) => setProveedoresCombustible(data));
  };

  useEffect(() => {
    obtenerProveedores();
  }, []);

  //*************************************************************************************************************************************/

  // DIALOG PARA AGREGAR PROVEEDOR
  const [dialogAgregar, setDialogAgregar] = useState(false);

  // Abrir diálogo
  const handleOpenAgregarProveedor = () => {
    setDialogAgregar(true);
  };

  // Cerrar diálogo
  const handleCloseAgregarProveedor = () => {
    setDialogAgregar(false);
  };

  //*************************************************************************************************************************************/

  const [proveedorSeleccionado, setProveedorSeleccionado] = useState(null);

  // DIALOG PARA CAMBIAR ESTADO DE LAS PROVEEDORES
  const [openCambiarEstadoProveedor, setOpenCambiarEstadoProveedor] =
    useState(false);

  const handleOpenCambiarEstadoProveedor = (row) => {
    setProveedorSeleccionado(row);
    setOpenCambiarEstadoProveedor(true);
  };

  const handleCloseCambiarEstadoProveedor = () => {
    setOpenCambiarEstadoProveedor(false);
  };

  //*************************************************************************************************************************************/

  // DIALOG PARA CAMBIAR ESTADO DE LAS PROVEEDORES
  const [openConfiguracionReporte, setOpenConfiguracionReporte] =
    useState(false);

  const handleOpenConfiguracionReporte = (row) => {
    setProveedorSeleccionado(row);
    setOpenConfiguracionReporte(true);
  };

  const handleCloseConfiguracionReporte = () => {
    setOpenConfiguracionReporte(false);
  };

  //*************************************************************************************************************************************/

  // ----------- TABLA ---------------
  const customLocalization = {
    ...MRT_Localization_ES,
    body: {
      ...MRT_Localization_ES.body,
      noData: "No hay registros para mostrar",
    },
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        size: 150,
      },
      {
        accessorKey: "proveedor",
        header: "Proveedor",
        size: 150,
      },
    ],
    []
  );

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { backgroundColor: "#ffffff" },
    variant: "outlined",
    size: "small",
  };

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  //*************************************************************************************************************************************/

  // Función para actualizar las proveedores luego de que se guarde uno nuevo
  const handleProveedorGuardado = () => {
    obtenerProveedores(); // Vuelve a obtener los datos actualizados
  };
  
useEffect(() => {
logEventos(
"acceso al menu Combustibles",
"Proveedores",
"Lista Proveedores de Combustible",
localStorage.getItem("user")
);
}, []);
  return (
    <>
      <Navbar />
      <Box
        sx={{
          marginTop: "20px",
          marginBottom: "25px",
          marginLeft: "40px",
          marginRight: "40px",
        }}
      >
        <ThemeProvider theme={tableTheme}>
          <MaterialReactTable
            columns={columns}
            data={proveedoresCombustible}
            initialState={initialState}
            positionActionsColumn="last"
            autoResetPageIndex={false}
            enableDensityToggle={false}
            enableFullScreenToggle={false}
            enableColumnActions={true}
            enableColumnFilters={false} // Desactiva filtros por columna
            enableHiding={false}
            localization={customLocalization}
            enableRowSelection={false}
            enableRowActions={true}
            muiTableHeadCellProps={tableHeadCellProps}
            muiSearchTextFieldProps={muiSearchTextFieldProps}
            muiTableBodyCellProps={({}) => ({
              align: "left",
              sx: {
                color: "black",
                borderColor: "black",
              },
            })}
            muiTableBodyRowProps={({ row }) => ({
              // Desactivo el hover default
              hover: false,
              sx: {
                // Color de la fila según su estado (Activo/inactivo)
                backgroundColor:
                  row.original.estado === 1 ? "#b3e6b3" : "#efc3c3",
                color: "black",
                borderColor: "black",
                // Hover personalizado
                "&:hover": {
                  backgroundColor:
                    row.original.estado === 1
                      ? lighten("#b3e6b3", 0.4)
                      : lighten("#efc3c3", 0.4),
                },
              },
            })}
            renderTopToolbarCustomActions={() => (
              <>
                <Typography variant="poster" fontSize={26}>
                  Proveedores de Combustible
                </Typography>
                <Button
                  variant="contained"
                  size="small"
                  style={{ marginTop: "5px" }}
                  startIcon={<AddBoxOutlinedIcon />}
                  onClick={handleOpenAgregarProveedor} // Abre el diálogo
                >
                  Agregar Proveedor
                </Button>
              </>
            )}
            renderRowActions={({ row }) => (
              <>
                <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                  <Tooltip
                    arrow
                    placement="left"
                    disableInteractive
                    title={
                      row.original.estado === 1
                        ? "Anular Proveedor"
                        : "Activar Proveedor"
                    }
                  >
                    <IconButton
                      onClick={() =>
                        handleOpenCambiarEstadoProveedor(row.original)
                      }
                    >
                      <BlockIcon
                        sx={{
                          color: row.original.estado === 1 ? "red" : "green",
                        }}
                      />
                    </IconButton>
                  </Tooltip>

                  <Tooltip
                    arrow
                    placement="left"
                    disableInteractive
                    title={"Configuración de Reporte"}
                  >
                    <IconButton
                      onClick={() =>
                        handleOpenConfiguracionReporte(row.original)
                      }
                      disabled={row.original.estado !== 1}
                      sx={{
                        color:
                          row.original.estado !== 1 ? "gray" : "primary.main",
                      }}
                    >
                      <SettingsIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
              </>
            )}
          />
        </ThemeProvider>
      </Box>

      {/* AGREGAR PROVEEDOR */}
      <Dialog
        fullWidth
        maxWidth={"xs"}
        open={dialogAgregar}
        onClose={handleCloseAgregarProveedor}
      >
        <AgregarProveedor
          handleCloseAgregarProveedor={handleCloseAgregarProveedor} // Función para cerrar el diálogo
          onProveedorGuardado={handleProveedorGuardado} // Recargar tabla al guardar
        />
      </Dialog>

      {/* CAMBIAR ESTADO PROVEEDOR */}
      <Dialog
        fullWidth
        maxWidth={"xs"}
        open={openCambiarEstadoProveedor}
        onClose={handleCloseCambiarEstadoProveedor}
      >
        <CambiarEstadoProveedor
          proveedor={proveedorSeleccionado}
          handleCloseCambiarEstadoProveedor={handleCloseCambiarEstadoProveedor} // Función para cerrar el diálogo
          onProveedorGuardado={handleProveedorGuardado} // Recargar tabla al guardar
        />
      </Dialog>

      {/* CONFIGURACION DE REPORTE */}
      <Dialog
        fullWidth
        maxWidth={"md"}
        open={openConfiguracionReporte}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            // Al presionar ESCAPE o Click a la zona sin dialog no hace nada, evita el cierre del diálogo
          } else {
            handleCloseConfiguracionReporte(event, reason);
          }
        }}
      >
        <ConfiguracionReporte
          proveedor={proveedorSeleccionado}
          handleCloseConfiguracionReporte={handleCloseConfiguracionReporte} // Función para cerrar el diálogo
          onProveedorGuardado={handleProveedorGuardado} // Recargar tabla al guardar
        />
      </Dialog>
    </>
  );
}

export default ProveedoresCombustible;
